import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { get } from 'lodash'
import { StaffDto } from '../Types/StaffDto'
import Staff from '../Classes/Staff'
import { UserAPIAdapter } from '../../../admin/vue/adapters/UserAPIAdapter'

export class StaffApiAdapter implements ApiDataAdapter<Staff> {
    public createClass(apiData: StaffDto): Staff {
        const user = get(apiData, '_ref_user')
        const staff: Staff = new Staff({
            id: get(apiData, 'personnel_id'),
            userId: get(apiData, 'user_id'),
            active: get(apiData, 'active'),
            role: get(apiData, 'emplacement'),
        })

        if (user) {
            staff.user = new UserAPIAdapter().createClass(user)
        }

        return staff
    }
}
